import mod from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProductListElement.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProductListElement.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductListElement.vue?vue&type=script&lang=js
// module id = Wk3M
// module chunks = 1